import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
const defaultFormat = (page, pageCount) => pageCount === void 0 ? `Page ${page}` : `Page ${page} of ${pageCount}`;
function Chevron({ direction }) {
  return /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: direction === "left" ? "M15 18l-6-6 6-6" : "M9 6l6 6-6 6",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
}
const Pagination = React.forwardRef(function Pagination2(props, ref) {
  const {
    page: pageProp,
    defaultPage = 1,
    pageCount,
    hasNextPage = true,
    onPageChange,
    disabled = false,
    previousLabel = "Previous",
    nextLabel = "Next",
    formatPageLabel = defaultFormat,
    className,
    "aria-label": ariaLabel = "Pagination",
    ...rest
  } = props;
  const controlled = pageProp !== void 0;
  const [uncontrolledPage, setUncontrolledPage] = React.useState(defaultPage);
  const page = controlled ? pageProp : uncontrolledPage;
  const canPrevious = !disabled && page > 1;
  const canNext = !disabled && (pageCount === void 0 ? hasNextPage : page < pageCount);
  const go = (next) => {
    if (!controlled) setUncontrolledPage(next);
    onPageChange?.(next);
  };
  return /* @__PURE__ */ jsxs("nav", { ref, className: cx("ev-pagination", className), "aria-label": ariaLabel, ...rest, children: [
    /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        className: "ev-btn ev-pagination__button",
        "aria-disabled": canPrevious ? void 0 : "true",
        onClick: () => {
          if (canPrevious) go(page - 1);
        },
        children: [
          /* @__PURE__ */ jsx(Chevron, { direction: "left" }),
          /* @__PURE__ */ jsx("span", { children: previousLabel })
        ]
      }
    ),
    /* @__PURE__ */ jsx("span", { className: "ev-pagination__label ev-num", "aria-live": "polite", "aria-atomic": "true", children: formatPageLabel(page, pageCount) }),
    /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        className: "ev-btn ev-pagination__button",
        "aria-disabled": canNext ? void 0 : "true",
        onClick: () => {
          if (canNext) go(pageCount === void 0 ? page + 1 : Math.min(page + 1, pageCount));
        },
        children: [
          /* @__PURE__ */ jsx("span", { children: nextLabel }),
          /* @__PURE__ */ jsx(Chevron, { direction: "right" })
        ]
      }
    )
  ] });
});
Pagination.displayName = "Pagination";
export {
  Pagination
};
//# sourceMappingURL=Pagination.js.map
